export const vacanciesFormConstants = {
  GO_TO: 'GO_TO',
  UPDATE_DATA_STEP1: 'UPDATE_DATA_STEP1',

  IS_LOADING: 'IS_LOADING_VACANCY',
  IS_LOADING2: 'IS_LOADING2_VACANCY',
  CLEAR_FORM: 'CLEAR_FORM_VACANCY',
  REDIRECT_TO: 'REDIRECT_TO_VACANCY',

  VACANCY_DATA: 'VACANCY_DATA',
  VACANCY_CONTACT_DATA: 'VACANCY_CONTACT_DATA',
  VACANCY_PROFILE_DATA: 'VACANCY_PROFILE_DATA',
};
